import { render, staticRenderFns } from "./OtpVerificationModal.vue?vue&type=template&id=16db0f02&scoped=true&"
import script from "./OtpVerificationModal.vue?vue&type=script&lang=js&"
export * from "./OtpVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./OtpVerificationModal.vue?vue&type=style&index=0&id=16db0f02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db0f02",
  null
  
)

export default component.exports